module.exports = __webpack_public_path__ + "img/q6-opt-d.442ba185.png";